import { z } from 'zod';

import { PaymentId } from '../BrandedIds';
import { DwollaBaseTransfer } from '../loan/Payments';
import { zodBrandedUuid } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CreateClawBackTransferEvent = BaseLoanEvent.extend({
  type: z.literal('createClawBackTransfer'),
  transfer: DwollaBaseTransfer,
  paymentId: zodBrandedUuid<PaymentId>(),
});
export type CreateClawBackTransferEvent = z.infer<typeof CreateClawBackTransferEvent>;
